<template>
<page>
  <!--
    <head-nav :title="$t('language.watson_assistant')">
      <icon-button-back slot="left"></icon-button-back>
      <icon-button-home slot="right"></icon-button-home>
    </head-nav>
-->
    <div class="video-container">
      <img :src="imgSrc">
      <span><h2 class="txt">Waarmee kan ik je van dienst zijn ?</h2></span>
    </div>
    
     
</page>
</template>

<script>

import { mapState } from 'vuex';
import Page from '../pages/Page';
//import HeadNav from '../components/HeadNav';
//import IconButtonHome from '../components/buttons/IconButtonHome';
//import IconButtonBack from '../components/buttons/IconButtonBack';
import { history } from "../services/History.js";


export default {
  name: 'view-watson-vraagbaak',
  data:function(){
    return {
      imgSrc:require('../assets/watson3dsmall.gif'),
    }
  },
  methods:{
    back(){
      this.$router.push(history.get());
    },
   
  },
  computed:{
     ...mapState([]),
     
  },
  components:{
    Page,
    //HeadNav,
    //IconButtonHome,
    //IconButtonBack,
  },
  created(){
  },
  mounted(){
  },
  beforeDestroy(){
  }
  
}




</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-container{
  position:relative;
  width:100%;
  height:100%;
  background-color:#171515;
  color:#FFFFFF;
  display:flex;
  align-items:center;
  justify-content:center;
  flex-direction: column;
}
.txt{
  font-weight:100;
  letter-spacing: 1px;
}
</style>
